import { useState, useEffect } from "react";
import { Box, Button, TextField, CircularProgress, Alert } from "@mui/material";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import AppDialog from "../../General/Dialog/AppDialog";

// Alta manual de juzgados que no vinieron en el roster del portal.
// `onCreate` es el servicio a usar (municipalidad o liquidaciones comunes).
export default function CreateDependencyDialog({ open, onClose, onCreate, onCreated }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName("");
      setError("");
    }
  }, [open]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Completá el nombre.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onCreate({ name: name.trim() });
      onCreated?.();
      onClose();
    } catch (e) {
      setError(
        e?.response?.data?.message ??
          e?.response?.data?.errors?.name?.[0] ??
          "Error al crear el juzgado.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Nuevo juzgado"
      maxWidth="sm"
      fullWidth
      stickyHeader
      actions={
        <>
          <Button onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            startIcon={
              saving ? <CircularProgress size={16} color="inherit" /> : <SaveRoundedIcon />
            }
            onClick={handleSave}
            disabled={saving}
            sx={{ borderRadius: 2, fontWeight: 900 }}
          >
            Guardar
          </Button>
        </>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 0.5 }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          label="Nombre del juzgado"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSave()}
          helperText="Escribilo exactamente como figura en el expediente para que se aplique su configuración."
          size="small"
          fullWidth
          autoFocus
        />
      </Box>
    </AppDialog>
  );
}
